import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function ClinicStats({ stats, isLoading, isSuccess }) {
  const navigate = useNavigate();
  const location=useLocation();

  if (isLoading) {
    return (
      <div className="stats-grid">
        {Array(4).fill(0).map((_, idx) => (
          <div key={idx} className="stat-card skeleton" />
        ))}
      </div>
    );
  }

  if (!isSuccess || !stats) {
    return (
      <div className="stats-grid">
        <p className="text-center">No stats available</p>
      </div>
    );
  }

  // Map API stats into cards
  const statCards = [
    {
      title: "Total Patients",
      value: stats?.totalPatients ?? 0,
      change: `${stats?.patientsChangePercent ?? 0}% compared to last period`,
      changeColor:
        (stats?.patientsChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      color: "#10b981",
      circleColor: "rgba(16, 185, 129, 0.15)",
      icon: <i className="fas fa-heartbeat"></i>,
    },
    {
      title: "Doctors",
      value: stats?.totalDoctors ?? 0,
      change: `${stats?.doctorsChangePercent ?? 0}% compared to last period`,
      changeColor:
        (stats?.doctorsChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      color: "#6366f1",
      circleColor: "rgba(99, 102, 241, 0.15)",
      icon: <i className="fas fa-user-md"></i>,
    },
    {
      title: "Appointments",
      value: stats?.totalAppointments ?? 0,
      change: `${stats?.appointmentsChangePercent?.toFixed(1) ?? 0}% compared to last period`,
      changeColor:
        (stats?.appointmentsChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      color: "#3b82f6",
      circleColor: "rgba(59, 130, 246, 0.15)",
      icon: <i className="fas fa-calendar-check"></i>,
    },
    {
      title: "Hospital Earnings",
      value: `₹${stats?.hospitalEarnings?.toLocaleString() ?? 0}`,
      change: `${stats?.earningsChangePercent ?? 0}% compared to last period`,
      changeColor:
        (stats?.earningsChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      color: "#f59e0b",
      circleColor: "rgba(245, 158, 11, 0.15)",
      icon: <i className="fas fa-dollar-sign"></i>,
    },
  ];

  return (
    <div className="stats-grid">
      {statCards.map((stat, index) => (
        <div key={index} className="stat-card">
          <span
            className="circle-before"
            style={{ background: stat.circleColor }}
          ></span>
          <span
            className="circle-after"
            style={{ background: stat.circleColor }}
          ></span>
          <div className="stat-content">
            <h3>{stat.value}</h3>
            <p className="stat-title">{stat.title}</p>
            <p className="stat-change" style={{ color: stat.changeColor }}>
              {stat.change}
            </p>
          </div>
          <div style={{ fontSize: "26px", color: stat.color }}>
            {stat.icon}
          </div>
        </div>
      ))}

      {/* Action Buttons */}
      <div className="action-buttons">
        <button className="action-btn" onClick={() => navigate(`/DoctorsAdd?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)}>
          + Add Doctor
        </button>
        <button
          className="action-btn"
          onClick={() => navigate(`/PatientsAdd?from=${encodeURIComponent(
              location.pathname + location.search
            )}`, { state: { showModal: true } })}
        >
          + Add Patient
        </button>
        <button className="action-btn">+ Add User</button>
        <button
          className="action-btn"
          onClick={() =>
            navigate("/AddAppointment", {
              state: { showModal: true, fromCreateEvent: true,from: location.pathname },
            })
          }
        >
          + Add Appointment
        </button>
      </div>
    </div>
  );
}

export default ClinicStats;
